import { Button, List, ListItem, Modal, TextField } from "@material-ui/core";
import React from "react";
import { add_special_dates_max_appointments, delete_special_dates_max_appointment, edit_special_dates_max_appointments, get_special_dates_max_appointment } from "../../../../api/API";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

const SpecialDates = (props) => {

    const [data, setData] = React.useState([]);
    const [showAddModal, setShowAddModal] = React.useState(false);
    const [showEditModal, setShowEditModal] = React.useState(false);

    const [form, setForm] = React.useState({
        max_pax: 5,
        start_date: '',
        end_date: ''
    });
    const [editForm, setEditForm] = React.useState({
        max_pax: 0,
        start_date: "",
        end_date: "",
        id: ""
    });
    React.useEffect(() => {
        get_data();
    }, []);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const get_data = () => {
        get_special_dates_max_appointment({
            property_id: props.property_id
        }).then(res => {
            setData(res.data);
        });
    };

    const handleChangeEdit = (e) => {
        setEditForm({
            ...editForm,
            [e.target.name]: e.target.value
        });


    };



    const handleSubmitEdit = () => {
        if (editForm.start_date == '' || editForm.end_date == '' || editForm.max_pax < 0) {
            alert("Please fill up all the fields");
            return;
        }
        edit_special_dates_max_appointments({
            special_dates_max_appointment_id: editForm.special_dates_max_appointment_id,
            property_id: props.property_id,
            start_date: editForm.start_date,
            end_date: editForm.end_date,
            max_pax: editForm.max_pax
        }).then(res => {
            if (res.status) {
                setShowEditModal(false);
                get_data();
            } else {
                alert(res.message);
            }
        });
    };

    const handleDelete = (id) => {
        delete_special_dates_max_appointment({
            special_dates_max_appointment_id: id
        }).then(res => {
            if (res.status) {
                alert("Deleted")
                get_data();
            }
        });
    };

    const handleSubmit = () => {
        if (form.start_date == '' || form.end_date == '' || form.max_pax < 0) {
            alert("Please fill up all the fields");
            return;
        }
        add_special_dates_max_appointments({
            property_id: props.property_id,
            start_date: form.start_date,
            end_date: form.end_date,
            max_pax: form.max_pax
        }).then(res => {
            if (res.status) {
                setShowAddModal(false);
                get_data();
            } else {
                alert(res.message);
            }

        });
    };

    return (<div>
        <div style={{
            display: 'flex',
            justifyContent: "flex-end",
            marginBottom: 20
        }}>


            <Button
                variant="contained"

                onClick={() => {
                    setShowAddModal(true)
                }}
                style={{

                }} >
                <AddIcon />
            </Button>
        </div>
        <table
            style={{
                width: "80%"
            }}
        >
            <tr>
                <th style={{
                    textAlign: "left"
                }}>From</th>
                <th style={{
                    textAlign: "left"
                }}>To</th>
                <th style={{
                    textAlign: "left"
                }}>Pax</th>
                <th></th>
            </tr>
            {data.map(res => (
                <tr>
                    <td style={{
                        padding: "0 10px"
                    }}>
                        {res.start_date}

                    </td>
                    <td>
                        {res.end_date}
                    </td>
                    <td>
                        {res.max_pax}
                    </td>
                    <td style={{
                        display: "flex"
                    }}>
                        <Button
                            // variant=""
                            style={{
                                marginRight: 10
                            }}
                        >
                            <EditIcon
                                onClick={() => {
                                    setShowEditModal(true);
                                    setEditForm({
                                        ...res
                                    });
                                }}
                            ></EditIcon>
                        </Button>
                        <Button
                            // variant="contained"
                        >
                            <DeleteIcon
                                onClick={() => {
                                    handleDelete(res.special_dates_max_appointment_id)
                                }}
                            ></DeleteIcon>
                        </Button>
                    </td>
                </tr>
            ))}
        </table>
        <Modal
            onClose={() => { setShowAddModal(false) }}
            open={showAddModal}>
            <div style={{
                backgroundColor: "white",
                width: 500,
                padding: 20,
                position: "relative",
                left: 0,
                right: 0,
                marginLeft: "auto",
                marginRight: "auto",
                top: '50%',
                transform: "translateY(-50%)"
            }}>
                <TextField label="Max Pax Per Appointment" fullWidth

                    name="max_pax"
                    value={form.max_pax}
                    onChange={handleChange}
                    style={{
                        marginBottom: 10
                    }}
                />
                <TextField

                    name="start_date"
                    value={form.start_date}
                    onChange={handleChange}
                    label="Date From" type="date"
                    InputLabelProps={{
                        shrink: true
                    }}
                    style={{
                        marginBottom: 10
                    }}
                    fullWidth />
                <TextField

                    name="end_date"
                    value={form.end_date}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true
                    }}
                    style={{
                        marginBottom: 10
                    }}
                    label="Date To" type="date" fullWidth />

                <div style={{
                    display: "flex",
                    justifyContent: "flex-end"
                }}>
                    <Button
                        onClick={handleSubmit}
                        variant="contained">Add</Button>
                </div>
            </div>
        </Modal>
        <Modal
            onClose={() => { setShowEditModal(false) }}
            open={showEditModal}>
            <div style={{
                backgroundColor: "white",
                width: 500,
                padding: 20,
                position: "relative",
                left: 0,
                right: 0,
                marginLeft: "auto",
                marginRight: "auto",
                top: '50%',
                transform: "translateY(-50%)"
            }}>
                <TextField label="Max Pax Per Appointment" fullWidth

                    name="max_pax"
                    value={editForm.max_pax}
                    onChange={handleChangeEdit}
                    style={{
                        marginBottom: 10
                    }}
                />
                <TextField

                    name="start_date"
                    value={editForm.start_date}
                    onChange={handleChangeEdit}
                    label="Date From" type="date"
                    InputLabelProps={{
                        shrink: true
                    }}
                    style={{
                        marginBottom: 10
                    }}
                    fullWidth />
                <TextField

                    name="end_date"
                    value={editForm.end_date}
                    onChange={handleChangeEdit}
                    InputLabelProps={{
                        shrink: true
                    }}
                    style={{
                        marginBottom: 10
                    }}
                    label="Date To" type="date" fullWidth />

                <div style={{
                    display: "flex",
                    justifyContent: "flex-end"
                }}>
                    <Button
                        onClick={handleSubmitEdit}
                        variant="contained">Save</Button>
                </div>
            </div>
        </Modal>
    </div>)
};

export default SpecialDates;
